import React from 'react';

export default function Location({
  mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15282225.79979123!2d73.7250244!3d20.7503702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30635ff06b92b791%3A0xd78c4fa1854213a6!2sIndia!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin",
  mapShareUrl = "https://maps.app.goo.gl/9n4hB49RpqXn5P6e7"
}) {
  return (
    <div className="map-3d-container">
      <style>{`
        .map-3d-container {
          perspective: 1000px;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .map-3d-card {
          width: 100%;
          max-width: 380px;
          height: 260px;
          background: var(--bg1);
          border: 1px solid var(--b);
          border-radius: 16px;
          overflow: hidden;
          position: relative;
          /* Fixed 3D tilt without cursor interaction */
          transform: rotateX(16deg) rotateY(-18deg) rotateZ(4deg);
          transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1), border-color 0.3s, box-shadow 0.3s;
          box-shadow: 
            -18px 18px 30px rgba(0, 0, 0, 0.75),
            0 0 40px rgba(232, 255, 71, 0.03);
        }
        .map-3d-card:hover {
          transform: rotateX(8deg) rotateY(-8deg) rotateZ(2deg) scale(1.02);
          border-color: rgba(232, 255, 71, 0.4);
          box-shadow: 
            -8px 8px 20px rgba(0, 0, 0, 0.6),
            0 0 50px rgba(232, 255, 71, 0.15);
        }
        .map-3d-iframe {
          width: 100%;
          height: 100%;
          border: 0;
          filter: invert(90%) hue-rotate(180deg) grayscale(0.2) brightness(0.8) contrast(1.15);
          transform: scale(1.1);
        }
        .map-overlay-header {
          position: absolute;
          top: 12px;
          left: 12px;
          background: rgba(13, 13, 18, 0.85);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          border: 1px solid var(--b2);
          border-radius: 20px;
          padding: 4px 10px;
          display: flex;
          align-items: center;
          gap: 6px;
          font-family: var(--M);
          font-size: 0.6rem;
          color: var(--t);
          letter-spacing: 1px;
          z-index: 10;
        }
        .map-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: var(--g);
          box-shadow: 0 0 6px var(--g);
          display: inline-block;
        }
        .map-overlay-btn {
          position: absolute;
          bottom: 12px;
          right: 12px;
          background: rgba(13, 13, 18, 0.85);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          border: 1px solid var(--b2);
          border-radius: 20px;
          padding: 5px 12px;
          font-family: var(--M);
          font-size: 0.62rem;
          color: var(--m);
          text-decoration: none;
          z-index: 10;
          transition: all 0.2s;
        }
        .map-overlay-btn:hover {
          color: var(--a);
          border-color: var(--a);
          background: rgba(232, 255, 71, 0.05);
        }
        @media (max-width: 900px) {
          .map-3d-card {
            transform: none; /* Flatten on mobile for better usability and layout */
            max-width: 100%;
            height: 220px;
            box-shadow: none;
            border-color: var(--b);
          }
          .map-3d-card:hover {
            transform: scale(1.01);
          }
        }
      `}</style>
      <div className="map-3d-card">
        <div className="map-overlay-header">
          <span className="map-dot" />
          <span>BASED IN INDIA</span>
        </div>
        <iframe
          src={mapEmbedUrl}
          title="Google Map Location"
          className="map-3d-iframe"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <a 
          href={mapShareUrl} 
          target="_blank" 
          rel="noreferrer" 
          className="map-overlay-btn"
        >
          Open Maps ↗
        </a>
      </div>
    </div>
  );
}
